var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReqAnsweredWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 16.5,
    viewBox: "0 0 16.5 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#fff;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16483.75 -8025.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16484 8026)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11,3a8,8,0,1,0,8,8A8.009,8.009,0,0,0,11,3Zm0,15.238A7.238,7.238,0,1,1,18.238,11,7.246,7.246,0,0,1,11,18.238Z",
    transform: "translate(-3 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.955,17.109a.372.372,0,0,1,0,.527l-4.213,4.213a.372.372,0,0,1-.527,0l-2.106-2.106a.372.372,0,1,1,.527-.527l1.843,1.843,3.949-3.949A.372.372,0,0,1,21.955,17.109Z",
    transform: "translate(-10.344 -11.611)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReqAnsweredWhite);
export default __webpack_public_path__ + "static/media/reqAnsweredWhite.f81deb212328f45157714d74d5567e76.svg";
export { ForwardRef as ReactComponent };